import { AssetsTypes } from '../constants/assetsConstants';

const initialState = {
    opened: false,
    asset: null,
    assetUpdate: null,
    contentUpdate: null,
};

export const assetsReducer = (state = initialState, action) => {
    switch (action.type) {
        case AssetsTypes.OPEN_CLOSE_VIEWER:
            return {
                ...state,
                opened: action.opened,
                asset: action.asset ?? state.asset,
            };

        case AssetsTypes.UPDATE_ASSET:
            return {
                ...state,
                assetUpdate: action.asset
            };

        case AssetsTypes.UPDATE_CONTENT:
            return {
                ...state,
                contentUpdate: action.content
            };

        case 'RESET':
            return {...initialState};

        default:
            return state;
    }
};